import React from 'react'
import { Meta } from '../../../components'
import { metaRenderer, useViewport } from '../../../utils'
import { useSystem } from '../../../features/system/hook'
import { useSelector } from 'react-redux'

const CardMetas = () => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const { isMobile } = useViewport()
  const data = useSelector(state => state.organization.data)
  const {
    approachOptions,
    organizationTypeOptions,
    issueOptions,
  } = useSystem()

  const {
    types,
    since,
    approaches,
    location,
    issues
  } = data

  const approachesRendered = metaRenderer(approaches, approachOptions)
  const typesRendered = metaRenderer(types, organizationTypeOptions)
  const issuesRendered = metaRenderer(issues, issueOptions)
  const sinceRendered = since === 0 || since === '0' ? '-' : since

  return !isMobile ? (
    <div className="justify-between w-full hidden lg:flex">
      <div className="w-1/5 pr-4">
        <Meta
          className="mb-5"
          label={translation.SEARCH.type[language.name]}
          value={typesRendered}
          light
        />
        <Meta
          label={translation.ORGANIZATION.since[language.name]}
          value={sinceRendered}
          light
        />
      </div>
      <div className="w-1/5 pr-4">
        <Meta
          className="mb-5"
          label={translation.APPROACH.singular[language.name]}
          value={approachesRendered}
          light
        />
        <Meta
          label={translation.GENERAL.location[language.name]}
          value={location}
          light
        />
      </div>
      <div className="w-3/5">
        <Meta
          label={translation.ISSUE.plural[language.name]}
          value={issuesRendered}
          light
        />
      </div>
    </div>
  ) : (
    <div className="flex justify-between w-full lg:hidden -mx-2">
      <div className="px-2">
        <Meta
          className="mb-5"
          label={translation.SEARCH.type[language.name]}
          value={typesRendered}
          light
        />
        <Meta
          label={translation.ISSUE.plural[language.name]}
          value={issuesRendered}
          light
        />
      </div>
      <div className="px-2">
        <Meta
          className="mb-5"
          label={translation.APPROACH.singular[language.name]}
          value={approachesRendered}
          light
        />
        <Meta
          label={translation.GENERAL.location[language.name]}
          value={location}
          light
        />
      </div>
      <div className="px-2">
        <Meta
          label={translation.ORGANIZATION.since[language.name]}
          value={sinceRendered}
          light
        />
      </div>
    </div>
  )
}

export { CardMetas }
